import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { HelpComponent } from '../help.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-help-guards',
  standalone: true,
  templateUrl: './help-guards.component.html',
  styleUrls: ['./help-guards.component.css'],
})
export class HelpGuardsComponent {
  readonly parent = input.required<HelpComponent>();
}
